import { LDFlags } from '../constants/flags';
import {
  ConsentAction,
  ConsentBasis,
  ConsentSource,
  useRecordConsentDecisionMutation,
} from '../gql/generated/graphql';
import { initializeTagManager } from '../services/analytics/googleTagManager';
import {
  VisitorRegion,
  getBrowserIdentifiers,
  getOptOutSource,
  hasPrivacySignal,
  isGpcEnabled,
  isOptedOut,
  resolveVisitorRegion,
  writePrivacyOptOut,
} from '../utils/privacy';
import useFlag from './useFlag';
import useOnce from './useOnce';

const useTagManagerGate = () => {
  const isPrivacyGateEnabled = useFlag(LDFlags.COM_PRIVACY_GTM_GATE);
  const [recordConsentDecision] = useRecordConsentDecisionMutation({
    context: { isErrorHandled: true },
    ignoreResults: true,
    onError: () => undefined,
  });

  const recordGpcOptOut = async (region: VisitorRegion) => {
    const identifiers = await getBrowserIdentifiers();
    if (!identifiers.length) {
      return;
    }

    await recordConsentDecision({
      variables: {
        decision: {
          basis: ConsentBasis.Gpc,
          action: ConsentAction.OptOut,
          source: ConsentSource.GpcAuto,
          ...region,
          page_url: `${window.location.origin}${window.location.pathname}`,
          identifiers,
        },
      },
    });
  };

  useOnce(() => {
    if (!hasPrivacySignal()) {
      return;
    }

    if (!isPrivacyGateEnabled) {
      initializeTagManager();
      return;
    }

    // A button opt-out holds in every state, gpc only in scope
    if (getOptOutSource() === 'button') {
      return;
    }

    const optedOut = isOptedOut();
    const isGpcOn = isGpcEnabled();

    resolveVisitorRegion().then((region) => {
      if (!region.in_scope) {
        initializeTagManager();
        return;
      }

      if (isGpcOn && !optedOut && writePrivacyOptOut('gpc')) {
        recordGpcOptOut(region);
      }
    });
  });
};

export default useTagManagerGate;
